console.log("Alerts JS Loaded");

function setCookie(name, value, days = 7) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const alertHTML = document.querySelector("#website-alert");

if (alertHTML) {
  alertHTML
    .querySelector(".alert__close")
    .addEventListener("click", function () {
      setCookie("alertDismissed", "true");
      alertHTML.remove();
    });

  document.addEventListener("DOMContentLoaded", function () {
    if (
      document.cookie
        .split(";")
        .some((item) => item.trim().startsWith("alertDismissed="))
    ) {
    } else {
      alertHTML.style.display = "block";
    }
  });
}
